import { render, staticRenderFns } from "./customer-dashboard.vue?vue&type=template&id=763fe4e7&scoped=true&"
import script from "./customer-dashboard.vue?vue&type=script&lang=js&"
export * from "./customer-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./customer-dashboard.vue?vue&type=style&index=0&id=763fe4e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763fe4e7",
  null
  
)

export default component.exports